export default __webpack_public_path__ + "static/media/bjornskalkam.dccf2d0b.jpeg";